import useHackathon from '@/data/hook/hackathon/useHackathon';
import { useTranslation } from 'react-i18next';
import ProjectSectionHeaderPage from '../ProjectSectionHeaderPage';
import HackathonPodium from './HackathonPodium';
import ListHackathonRanking from './ListHackathonRanking';
import { CarouselFilters } from '@/components/projects/carousel/filters/CarouselFilterProps';
import { useState } from 'react';

export default function ProjectHackathonRankingPage() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'projects.page',
  });

  const [filter, setFilter] = useState<CarouselFilters>({
    courseType: [],
  });

  const { hackathon } = useHackathon();
  if (!hackathon) return null;
  return (
    <div className="w-full flex flex-col">
      <ProjectSectionHeaderPage
        title={`#${t('hackathon')}${hackathon?.edition}`}
        hiddenFilter
        className={{
          title: '!text-primary text-20',
        }}
      />
      <HackathonPodium
        hackathon={hackathon}
        filter={filter}
        onFilter={setFilter}
      />
      <ListHackathonRanking hackathon={hackathon} filters={filter} />
    </div>
  );
}
